import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DropdownOption } from '../components/product/product.types';
import { map } from 'rxjs/operators';
import { CountryAttr } from './spree-client/storefront';
import { SpreeService } from './spree-client/storefront/spree.service';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private readonly client = inject(SpreeService);

  getCountry(iso: string): Observable<Country> {
    return this.client.countries
      .show({ iso: iso })
      .pipe(map((data) => deserializeCountry(data.data)));
  }

  getCountryByKey(
    key: string,
    availableCountries: DropdownOption[]
  ): Country | undefined {
    const countries = availableCountries.map((value) => value.value) as Country[];

    if (key === 'cs') {
      key = 'CZ';
    }

    return countries.find((c) => c.key === key.toUpperCase());
  }

  getAvailableCountriesAsDropdown(): Observable<DropdownOption<Country>[]> {
    return this.client.countries.list().pipe(
      map(({ data }) => {
        const countries = deserializeCountries(data);

        return deserializeCountriesToDropdown(countries);
      })
    );
  }
}

export const deserializeCountriesToDropdown = (
  countries: Country[]
): DropdownOption<Country>[] => {
  return countries.map((c) => {
    return {
      value: c,
      valueId: c.id,
      name: c.label,
    } as DropdownOption<Country>;
  });
};

export const deserializeCountries = (countries: CountryAttr[]): Country[] => {
  return countries.map((country) => {
    return deserializeCountry(country);
  });
};

export const deserializeCountry = (country: CountryAttr): Country => {
  return {
    id: country.id,
    key: country.attributes.iso,
    label: country.attributes.name,
    stateRequired: country.attributes.states_required,
    postalCodeRequired: country.attributes.zipcode_required,
    isDefault: country.attributes.default,
    countryIso: country.attributes.iso3,
  } as Country;
};

export type Country = {
  id: string;
  key: string;
  label: string;
  stateRequired: boolean;
  postalCodeRequired: boolean;
  isDefault: boolean;
  countryIso: string;
};
